"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartContainerUpdateStateSelector = void 0;
const get_chart_theme_1 = require("./get_chart_theme");
const get_internal_can_display_chart_titles_1 = require("./get_internal_can_display_chart_titles");
const get_legend_config_selector_1 = require("./get_legend_config_selector");
const create_selector_1 = require("../create_selector");
exports.getChartContainerUpdateStateSelector = (0, create_selector_1.createCustomCachedSelector)([get_legend_config_selector_1.getLegendConfigSelector, get_chart_theme_1.getChartThemeSelector, get_internal_can_display_chart_titles_1.getInternalCanDisplayChartTitles], (legendConfig, theme, displayTitles) => {
    return {
        paddingLeft: theme.chartMargins.left,
        paddingRight: theme.chartMargins.right,
        displayTitles,
        legendDirection: legendConfig.legendPosition.direction,
    };
});
//# sourceMappingURL=chart_container_updates.js.map